import { render, staticRenderFns } from "./updateReview.vue?vue&type=template&id=db7bec4a&scoped=true&"
import script from "./updateReview.vue?vue&type=script&lang=js&"
export * from "./updateReview.vue?vue&type=script&lang=js&"
import style0 from "./updateReview.vue?vue&type=style&index=0&id=db7bec4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7bec4a",
  null
  
)

export default component.exports